var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quick-view-btn-container",attrs:{"id":"quick-view-btn-container"},on:{"click":function($event){return _vm.openQuickView({event: $event})}}},[_c('span',{staticClass:"rango-zoom-plus"}),_vm._v(" "),_c('button',{attrs:{"type":"button"}},[_vm._v(_vm._s(_vm.__('products.quick-view')))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57622426","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resources/assets/js/UI/components/product-quick-view-btn.vue
// module id = 1CXp
// module chunks = 0